var map = {
	"./a-minute-or-2-01-01-2024.json": 4288,
	"./bigger-man-01-01-2024.json": 5970,
	"./each-year-05-28-2024.json": 3737,
	"./everything-01-01-2024.json": 4566,
	"./freak-out-01-01-2024.json": 7699,
	"./it-aint-nun-feat-nbt-motion-01-01-2024.json": 7593,
	"./kind-01-01-2024.json": 4553,
	"./mortified-feat-jack-zebra-05-28-2024.json": 3102,
	"./treat-myself-05-28-2024-1.json": 6980,
	"./treat-myself-05-28-2024.json": 5658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2512;